import React from "react";
import { DataTable } from "@/components/DataTable";
import {
  Button,
  MenubarContent,
  MenubarItem,
  Menubar,
  MenubarTrigger,
  MenubarMenu,
} from "@/components/ui";
import { MoreVertical } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BulkMessage } from "@/__generated__/graphql";
import { Row } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/paths";
import { DeleteButton } from "../BulkMessaging/Components/DeleteButton";

export const EditBulkMessageActions = ({
  row,
}: {
  row: Row<BulkMessage | null>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = row.original || {};

  return (
    <DataTable.TBodyCell isLastCell={true}>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={() =>
            navigate(`${id}/${ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.EDIT}`)
          }
        >
          {t("bulkMessaging.table.editActions")}
        </Button>
        <Menubar>
          <MenubarMenu>
            <MenubarTrigger
              role="menuitem"
              aria-label={t("dataTable.openTableActionsMenu")}
              aria-haspopup="true"
              className={`cursor-pointer p-2 hover:bg-muted`}
            >
              <MoreVertical className="h-4 w-4" aria-hidden="true" />
            </MenubarTrigger>
            <MenubarContent
              align="end"
              role="menu"
              data-testid="table-actions-menu"
              aria-label={t("dataTable.tableActions")}
              aria-orientation="vertical"
            >
              <MenubarItem
                onClick={(e) => e.preventDefault()}
                variant="destructive"
                role="menuitem"
                aria-label={t("bulkMessaging.table.delete.name")}
              >
                <DeleteButton id={id}>
                  <button className="w-full text-left">
                    {t("bulkMessaging.table.delete.name")}
                  </button>
                </DeleteButton>
              </MenubarItem>
            </MenubarContent>
          </MenubarMenu>
        </Menubar>
      </div>
    </DataTable.TBodyCell>
  );
};
